export var GET_ASSIGNED_FREELANCERS = '[Freelancers] Get Assigned Freelancers';
export var GET_ASSIGNED_FREELANCERS_SUCCESS = '[Freelancers] Get Assigned Freelancers Success';
export var GET_ASSIGNED_FREELANCERS_ERROR = '[Freelancers] Get Assigned Freelancers Error';
export var GET_FREELANCER = '[Freelancers] Get Freelancer';
export var GET_FREELANCER_SUCCESS = '[Freelancers] Get Freelancer Success';
export var GET_FREELANCER_ERROR = '[Freelancers] Get Freelancer Error';
export var GET_APPROVED_FREELANCERS = '[Freelancers] Get Approved Freelancers';
export var GET_APPROVED_FREELANCERS_SUCCESS = '[Freelancers] Get Approved Freelancers Success';
export var GET_APPROVED_FREELANCERS_ERROR = '[Freelancers] Get Approved Freelancers Error';
export var UPDATE_ASSIGNED_FREELANCERS = '[Freelancers] Update Assigned Freelancers';
export var UPDATE_ASSIGNED_FREELANCERS_SUCCESS = '[Freelancers] Update Assigned Freelancers Success';
export var UPDATE_ASSIGNED_FREELANCERS_ERROR = '[Freelancers] Update Assigned Freelancers Error';
var GetAssignedFreelancers = /** @class */ (function () {
    function GetAssignedFreelancers(payload) {
        this.payload = payload;
        this.type = GET_ASSIGNED_FREELANCERS;
    }
    return GetAssignedFreelancers;
}());
export { GetAssignedFreelancers };
var GetAssignedFreelancersSuccess = /** @class */ (function () {
    function GetAssignedFreelancersSuccess(payload) {
        this.payload = payload;
        this.type = GET_ASSIGNED_FREELANCERS_SUCCESS;
    }
    return GetAssignedFreelancersSuccess;
}());
export { GetAssignedFreelancersSuccess };
var GetAssignedFreelancersError = /** @class */ (function () {
    function GetAssignedFreelancersError(payload) {
        this.payload = payload;
        this.type = GET_ASSIGNED_FREELANCERS_ERROR;
    }
    return GetAssignedFreelancersError;
}());
export { GetAssignedFreelancersError };
var GetFreelancer = /** @class */ (function () {
    function GetFreelancer(payload) {
        this.payload = payload;
        this.type = GET_FREELANCER;
    }
    return GetFreelancer;
}());
export { GetFreelancer };
var GetFreelancerSuccess = /** @class */ (function () {
    function GetFreelancerSuccess(payload) {
        this.payload = payload;
        this.type = GET_FREELANCER_SUCCESS;
    }
    return GetFreelancerSuccess;
}());
export { GetFreelancerSuccess };
var GetFreelancerError = /** @class */ (function () {
    function GetFreelancerError(payload) {
        this.payload = payload;
        this.type = GET_FREELANCER_ERROR;
    }
    return GetFreelancerError;
}());
export { GetFreelancerError };
var GetApprovedFreelancers = /** @class */ (function () {
    function GetApprovedFreelancers(payload) {
        this.payload = payload;
        this.type = GET_APPROVED_FREELANCERS;
    }
    return GetApprovedFreelancers;
}());
export { GetApprovedFreelancers };
var GetApprovedFreelancersSuccess = /** @class */ (function () {
    function GetApprovedFreelancersSuccess(payload) {
        this.payload = payload;
        this.type = GET_APPROVED_FREELANCERS_SUCCESS;
    }
    return GetApprovedFreelancersSuccess;
}());
export { GetApprovedFreelancersSuccess };
var GetApprovedFreelancersError = /** @class */ (function () {
    function GetApprovedFreelancersError(payload) {
        this.payload = payload;
        this.type = GET_APPROVED_FREELANCERS_ERROR;
    }
    return GetApprovedFreelancersError;
}());
export { GetApprovedFreelancersError };
var UpdateAssignedFreelancers = /** @class */ (function () {
    function UpdateAssignedFreelancers(payload) {
        this.payload = payload;
        this.type = UPDATE_ASSIGNED_FREELANCERS;
    }
    return UpdateAssignedFreelancers;
}());
export { UpdateAssignedFreelancers };
var UpdateAssignedFreelancersSuccess = /** @class */ (function () {
    function UpdateAssignedFreelancersSuccess(payload) {
        this.payload = payload;
        this.type = UPDATE_ASSIGNED_FREELANCERS_SUCCESS;
    }
    return UpdateAssignedFreelancersSuccess;
}());
export { UpdateAssignedFreelancersSuccess };
var UpdateAssignedFreelancersError = /** @class */ (function () {
    function UpdateAssignedFreelancersError(payload) {
        this.payload = payload;
        this.type = UPDATE_ASSIGNED_FREELANCERS_ERROR;
    }
    return UpdateAssignedFreelancersError;
}());
export { UpdateAssignedFreelancersError };



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/freelancers/store/actions/freelancer.action.ts.pre-build-optimizer.js